export default function Counters() {

    return (
        <>
            <div className="counter-item-outer">
                <div className="counter-item">
                    <div className="counter-number">25+</div>
                    <div className="counter-text">
                        <span className="counter-line">Student Nationality</span>
                    </div>
                </div>

                <div className="counter-item">
                    <div className="counter-number">2700+</div>
                    <div className="counter-text">
                        <span className="counter-line">Students Enrolled</span>
                    </div>
                </div>

                <div className="counter-item">
                    <div className="counter-number">100+</div>
                    <div className="counter-text">
                        <span className="counter-line">Courses We Offer</span>
                    </div>
                </div>

                <div className="counter-item">
                    <div className="counter-number">35+</div>
                    <div className="counter-text">
                        <span className="counter-line">Expert Trainers</span>
                    </div>
                </div>

                <div className="counter-item">
                    <div className="counter-number">3+</div>
                    <div className="counter-text">
                        <span className="counter-line">Years of Excellence</span>
                    </div>
                </div>
            </div>
        </>
    );
}